module.exports = __webpack_public_path__ + "media/images/glyphicons-halflings-red-e43dc028.png";